module.exports = __webpack_public_path__ + "static/img/3-5.9961494.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/3-5.jpg
// module id = vu5K
// module chunks = 1